import * as React from 'react';
import { useStyles, isNumber, isUndefined } from '@sravni/react-utils';
import { FONT_SIZES } from '../../../constants/sizes.js';
import modules_6a168f0b from '../styles/Text.module.less.js';

/** Helper function */
const convertSizeAdaptiveToClassNames = (size) => {
    if (isUndefined(size))
        return [];
    const breakpoints = Object.keys(size);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? size[breakpoint]
        : `${breakpoint}-${size[breakpoint]}`;
    return breakpoints.map((breakpoint) => `size-${createName(breakpoint)}`);
};
/**
 * @description The Text component is used for single line or multiline text. The component renders a div element by default
 *
 * @component
 * @example
 * ```jsx
 * <Text as="div" size="xl" strong>Text</Text>
 * ```
 */
const Text = React.forwardRef((props, ref) => {
    const { as, size, strong, uppercase, capitalize, lowercase, truncate, nowrap, lineThrough, className, children, ...restProps } = props;
    const cx = useStyles(modules_6a168f0b);
    const sizeAdaptive = React.useMemo(() => (isNumber(size) ? { mobile: size } : size), [size]);
    const classNames = cx(className, {
        strong,
        uppercase,
        capitalize,
        lowercase,
        truncate,
        nowrap,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'line-through': lineThrough,
    }, ...convertSizeAdaptiveToClassNames(sizeAdaptive));
    return React.createElement(as, {
        ref,
        className: classNames,
        ...restProps,
    }, children);
});
Text.defaultProps = {
    size: FONT_SIZES.S14,
    as: 'div',
};
Text.displayName = 'Text';

export { Text };
//# sourceMappingURL=Text.js.map
